export default __webpack_public_path__ + "static/psicologia-mobile-38144d552066d0e3213a0f29e217771a.svg";